// extracted by mini-css-extract-plugin
export default {"pills":"_1qxehip"};